import React from 'react';
import { Message } from 'semantic-ui-react';

const Disclaimer = () => {
	return (
		<Message className={`kootenai-disclaimer`}>
			<p>
				<strong>Disclaimer: </strong>
				This form is for informational purposes only. Kootenai Title and Bonner
				Title reserve the right to prepare actual closing statements based on
				signed purchase and sale agreements and addendums. This information does
				not include any Homeowners Association Prorations, Property Tax
				Prorations, or assessments for irrigation, etc.
			</p>

			<p>
				This form does not provide data for homes with a sale price of more than
				one million dollars. For higher priced homes, please contact us
				directly.
			</p>
		</Message>
	);
};

export default Disclaimer;
